/* global gsap */
const {KitModule, registerModule} = window;

// no space as it will be triggered from click
const OPEN_SUBNAV_KEYS = ['Enter', 'ArrowDown'];

// used for debounce
let timeout;

class Nav extends KitModule {
  constructor($element) {
    super($element);

    this.setVars();
    this.bindEvents();
    this.buildTl();
  }

  setVars() {
    this.$menuCheckbox = document.querySelector('.nav-menu-checkbox');
    this.searchIsOpen = false;
    this.previousScrollY = window.scrollY;
  }

  bindEvents() {
    // events
    this.$element.addEventListener('keydown', this);
    this.$element.addEventListener('click', this);
    this.$menu.addEventListener('mouseover', this);
    this.$menuCheckbox.addEventListener('change', this);
    this.$menuLabel.addEventListener('click', this.onMenuLabelClick.bind(this));

    // window.addEventListener('searchopen', this);
    // window.addEventListener('searchclose', this);

    /**
     * Hat tip: https://gomakethings.com/debouncing-events-with-requestanimationframe-for-better-performance/
     */
    window.addEventListener('scroll', () => {
      // If there's a timer, cancel it
      if (timeout) {
        window.cancelAnimationFrame(timeout);
      }

      // Setup the new requestAnimationFrame()
      timeout = window.requestAnimationFrame(() => {
        // Run our scroll functions
        this.onscroll();
      });
    });

    this.bindMediaQuery();

    // window.addEventListener('resize', this);
  }

  // onresize() {
  //   if (this.isDesktop) {
  //     this.$menuCheckbox.checked = false;
  //     this.isMenuOpen = this.$menuCheckbox.checked;
  //     document.documentElement.classList.remove('nav-menu-open', this.isMenuOpen);
  //     // this.isMenuOpen ? this.tl.play(0) : this.tl.reverse();
  //     gsap.set('.nav__menu, .nav__list--primary, .bar1, .bar2, .bar3', {clearProps: true});
  //     gsap.set('.bar', {
  //       transformOrigin: '50% 50%',
  //     });
  //   }
  // }

  bindMediaQuery() {
    // get media query from custom property
    const rootStyle = getComputedStyle(document.documentElement);

    // max nav - mobile
    const maxQuery = rootStyle.getPropertyValue('--max-nav-media-query');
    this.maxMediaQuery = window.matchMedia(maxQuery);
    // listen and set initial
    this.maxMediaQuery.addEventListener('change', this.onMaxMediaChange.bind(this));
    this.onMaxMediaChange(this.maxMediaQuery);

    // min nav - desktop
    const minQuery = rootStyle.getPropertyValue('--min-nav-media-query');
    this.minMediaQuery = window.matchMedia(minQuery);
    // listen and set initial
    this.minMediaQuery.addEventListener('change', this.onMinMediaChange.bind(this));
    this.onMinMediaChange(this.maxMediaQuery);
  }

  onMaxMediaChange(mobileMediaQuery) {
    // mobile
    if (mobileMediaQuery.matches) {
      this.isMobile = true;
      this.isDesktop = false;
      this.$menuCheckbox.checked = false;
    }

    document.documentElement.classList.remove('nav-menu-open');
    gsap.set('.nav__menu, .nav__list--primary, .bar1, .bar2, .bar3', {clearProps: true});
    gsap.set('.bar', {
      transformOrigin: '50% 50%',
    });
  }

  onMinMediaChange(desktopMediaQuery) {
    // desktop
    if (desktopMediaQuery.matches) {
      this.isDesktop = true;
      this.isMobile = false;
      this.$menuCheckbox.checked = false;
    }

    document.documentElement.classList.remove('nav-menu-open');

    gsap.set('.nav__menu, .nav__list--primary, .bar1, .bar2, .bar3', {clearProps: true});
    gsap.set('.bar', {
      transformOrigin: '50% 50%',
    });
  }

  // onsearchopen() {
  //   this.searchIsOpen = true;
  //   if (this.isMenuOpen) this.$menuCheckbox.click();
  // }

  // onsearchclose() {
  //   this.searchIsOpen = false;
  //   if (this.isMobile) {
  //     this.closeSubnav();
  //     if (this.isMenuOpen) this.$menuCheckbox.click();
  //   }
  // }

  // toggle subnav on .nav__item__button click
  onclick(event) {
    const $itemButton = event.target.closest('.nav__item__button');
    if (!$itemButton) return;

    const $item = $itemButton.closest('.nav__item');
    this.toggleSubnav($item);
  }

  onkeydown(event) {
    if (event.key === 'Escape') {
      this.closeSubnav();
      if (this.isMenuOpen) this.$menuCheckbox.click();
      return;
    }
    const isOpeningSubnav = OPEN_SUBNAV_KEYS.includes(event.key) &&
      event.target.matches('.nav__item__button--subnav');

    if (isOpeningSubnav) {
      event.preventDefault();
      const $item = event.target.closest('.nav__item');
      if ($item === this.$openSubnavItem && event.key !== 'ArrowDown') {
        this.closeSubnav();
      } else {
        this.openSubnav($item);
      }
    }
  }

  // close subnav if hovered over other item, desktop only
  onmouseover(event) {
    if (this.isMobile) return;
    const $item = event.target.closest('.nav__item');
    if ($item && $item !== this.$openSubnavItem) this.closeSubnav();
  }

  onscroll() {
    if (window.innerWidth < 1000) {
      this.$element.classList.add('show');
      this.$element.classList.add('is-stuck');
      this.$element.classList.add('js-scroll-reveal');

      return;
    }

    const currentScrollY = window.scrollY;

    if (currentScrollY < this.previousScrollY) {
      this.$element.classList.add('show');
      this.$element.classList.add('is-stuck');
      this.$element.classList.add('js-scroll-reveal');
    } else if (currentScrollY > 56) { // 56 is top padding of most sections
      this.$element.classList.remove('show');
    }

    if (currentScrollY < this.$element.clientHeight) {
      this.$element.classList.remove('is-stuck');
      this.$element.classList.remove('js-scroll-reveal');
    }

    this.previousScrollY = currentScrollY;
  }

  buildTl() {
    // const q = gsap.utils.selector(this);
    const bar = document.querySelectorAll('.bar');
    gsap.set(bar, {
      transformOrigin: '50% 50%',
    });

    this.tl = gsap.timeline({
      paused: true,
      defaults: {
        duration: 0.25,
        ease: 'power1.in',
      },
    });

    this.tl
      .to('.nav__menu', {
        opacity: 1,
        display: 'grid',
        ease: 'linear',
      }, 0)
      .to('.nav__list--primary', {
        opacity: 1,
        y: 0,
      }, '>-=0.2')
      .to('.bar1', {
        y: 8,
      }, 0)
      .to('.bar3', {
        y: -8,
      }, 0)
      .to('.bar2', {
        opacity: 0,
      }, 0)
      .addLabel('rotate', '>')
      .to('.bar1', {
        rotation: 45,
        ease: 'back.out(2)',
      }, 'rotate')
      .to('.bar3', {
        rotation: -45,
        ease: 'back.out(2)',
      }, 'rotate')
      .to('.bar', {
        scaleX: Math.SQRT2, // needed to maintain polyline width
        duration: 0.5,
        ease: 'power1.inOut',
      }, 0);
  }

  onchange() {
    this.isMenuOpen = this.$menuCheckbox.checked;
    document.documentElement.classList.toggle('nav-menu-open', this.isMenuOpen);

    this.isMenuOpen ? this.tl.play(0) : this.tl.reverse();
  }

  // programmatically trigger click to avoid browser setting scroll position to top
  onMenuLabelClick(event) {
    event.preventDefault();

    if (this.searchIsOpen) {
      const customEvent = new Event('menulabelclicked');
      window.dispatchEvent(customEvent);
    }

    this.$menuCheckbox.click();
  }

  openSubnav($item) {
    if (!$item) return;

    this.closeSubnav(this.$openSubnavItem); // close previous

    this.$openSubnavItem = $item;
    this.$openSubnavButton = $item.querySelector('.nav__item__button');
    this.$openSubnavItem.classList.add('is-subnav-open');
    this.$openSubnavButton.setAttribute('aria-expanded', 'true');
  }

  closeSubnav() {
    if (!this.$openSubnavItem) return;

    this.$openSubnavItem.classList.remove('is-subnav-open');
    this.$openSubnavButton.setAttribute('aria-expanded', 'false');
    this.$openSubnavItem = null;
    this.$openSubnavButton = null;
  }

  toggleSubnav($item) {
    if ($item === this.$openSubnavItem) {
      this.closeSubnav();
    } else {
      this.openSubnav($item);
    }
  }

  unmount() {
    this.$element.removeEventListener('keydown', this);
    this.mediaQuery.removeEventListener('change', this.onMediaChange);
    this.$menu.removeEventListener('mouseover', this);
    this.$menuCheckbox.removeEventListener('change', this);
  }
}

registerModule('Nav', Nav);
